import { Modal, Table } from "antd";
import { useEffect, useState } from "react";
import service from "../../../@services";

export default props => {
  const {visible,no,close, way} = props
  const [dataSource, setTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
  useEffect(()=>{
    setTableData([])
    if(visible){
      fetchData({no, pageIndex: 1, pageSize: 10, way})
    }
  },[visible])
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = {way, no, pageIndex: pagination.current, pageSize: pagination.pageSize}
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.inventory.allocationOperateLogs(params)
    setLoading(false)
    if(data){
      setTableData(data.result)
      setPagination({
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const columns = [
    { title: '操作描述', dataIndex: 'actDesc', key: 'actDesc' },
    { title: '操作人', dataIndex: 'operator', key: 'operator' },
    { title: '操作时间', dataIndex: 'createTime', key: 'createTime' }
  ]
  return (
    <Modal
      visible={visible}
      width="40%"
      title="操作日志"
      onCancel={close}
      footer={[]}
    >
      <Table
        rowKey={record=>record.id}
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Modal>
  );
}
